// extracted by mini-css-extract-plugin
export default {"container":"Address_container__LQVnB","warning":"Address_warning__HqmEp","points":"Address_points__YNK9j","noAddress":"Address_noAddress__LAY8Z"};